import { Button } from "@mui/material";
import FieldArrayHeading from "components/molecules/FieldArrayHeading";
import { useEffect, useRef } from "react";
import BookingForm from "./BookingForm";

const BookingDetails = ({ fields }: any) => {
  const isSet = useRef(false);

  useEffect(() => {
    if (isSet.current) return;

    fields.push({});

    isSet.current = true;
  }, [fields]);
  return (
    <div>
      <h2>Bookings</h2>
      {fields.map((member: string, index: number) => (
        <div key={index}>
          <FieldArrayHeading
            index={index}
            heading={"Booking"}
            fieldsLength={fields.length}
            onClick={() => fields.remove(index)}
          />
          <BookingForm index={index} member={member} />
        </div>
      ))}
      <Button type="button" onClick={() => fields.push({})}>
        Add More Booking
      </Button>
    </div>
  );
};

export default BookingDetails;
